<template>
    <div>
        <div class="page-title-area item-bg-1">
            <div class="d-table">
                <div class="d-table-cell">
                    <div class="container">
                        <div class="page-title-content">
                            <h2>Mi cuenta</h2>
                            <ul>
                                <li><a href="/">Inicio</a></li>
                                <li>Mi cuenta</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <section class="blog-area ptb-100">
            <div class="container">
                <div class="row">
                    <div class="col-lg-3 col-md-12">
                        <aside class="widget-area" id="secondary">
                            <section
                                class="widget widget_categories"
                                style="box-shadow: rgb(0 0 0 / 40%) 0px 0px 15px, rgb(255 255 255) 0px 0px 5px inset; border-radius: 10px;"
                            >
                                <h3
                                    class="widget-title"
                                    style="font-size: 20px"
                                >
                                    Menú
                                </h3>
                                <ul>
                                    <li>
                                        <a
                                            href="#"
                                            v-bind:class="{ active: tab == 0 }"
                                            @click.prevent="tab = 0"
                                            >Datos personales</a
                                        >
                                    </li>
                                    <li>
                                        <a
                                            href="#"
                                            v-bind:class="{ active: tab == 1 }"
                                            @click.prevent="tab = 1"
                                            >Mis pólizas</a
                                        >
                                    </li>
                                    <li>
                                        <a
                                            href="#"
                                            v-bind:class="{ active: tab == 2 }"
                                            @click.prevent="tab = 2"
                                            >Cotizaciones</a
                                        >
                                    </li>
                                    <li>
                                        <a
                                            href="#"
                                            v-bind:class="{ active: tab == 7 }"
                                            @click.prevent="tab = 7"
                                            >Certificados</a
                                        >
                                    </li>
                                    <li>
                                        <a
                                            href="#"
                                            v-bind:class="{ active: tab == 4 }"
                                            @click.prevent="tab = 4"
                                            >Documentos</a
                                        >
                                    </li>
                                    <li>
                                        <a
                                            href="#"
                                            v-bind:class="{ active: tab == 3 }"
                                            @click.prevent="tab = 3"
                                            >Reclamaciones</a
                                        >
                                    </li>
                                    <li>
                                        <a
                                            href="#"
                                            v-bind:class="{ active: tab == 5 }"
                                            @click.prevent="tab = 5"
                                            >Facturación</a
                                        >
                                    </li>
                                    <li>
                                        <a
                                            href="#"
                                            v-bind:class="{ active: tab == 6 }"
                                            @click.prevent="tab = 6"
                                            >Seguridad</a
                                        >
                                    </li>
                                </ul>
                            </section>
                            <br />
                            <button
                                @click.prevent="$methods.logout()"
                                class="btn btn-danger btn-block w-100"
                            >
                                Cerrar sesión
                            </button>
                        </aside>
                    </div>
                    <div class="col-lg-9 col-md-12">
                        <div class="row">
                            <div
                                class="alert alert-warning"
                                role="alert"
                                style="
                                    box-shadow: rgb(0 0 0 / 40%) 0px 0px 15px,
                                        rgb(255 255 255) 0px 0px 5px inset;
                                "
                            >
                                Realice su diagnostico y conozca los productos
                                que cumplen sus necesidades
                                <div style="float: right">
                                    <button class="btn btn-danger">
                                        Realizar
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>

import { mapState, mapActions } from "vuex";
export default {
    mounted() {

    },
    data: function () {
        return {
            tab: 0,
        };
    },
    methods: {
        ...mapActions("security", ["isAuth"]),
    },
    computed: {
        ...mapState("security", ["authenticate"]),
    },
};
</script>

<style>
.form-control{
    border-radius: 20px;
}
</style>
